<template>
    <div class="text-center mt-2">
        <v-dialog  :scrollable="false" width="500" v-model="dialog">
            <template v-slot:activator="{ on }">
                <v-btn class="btnNoPadding" text color="warning" dark v-on="on">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>

            <v-card class="ma-0">
                <v-card-title class="text-center">
                    <div class="pt-2 cardTitle synThickFont">Edit Song</div>
                </v-card-title>

                <v-card-text>
                    <v-form class="px-3 pt-3 synThinFont" ref="form">
                        <v-text-field 
                            label="Song Title" 
                            v-model="current_song.title" 
                            prepend-icon="mdi-folder" 
                            :rules="titleRules"
                        ></v-text-field>
                        <v-select 
                            :items="genreItems" 
                            label="Song Genre" 
                            v-model="current_song.genre" 
                            prepend-icon="mdi-folder" 
                            :rules="genreRules"
                        ></v-select>
                        <!-- <v-text-field 
                            label="Song Link (SoundCloud)" 
                            v-model="current_song.soundcloud" 
                            prepend-icon="mdi-music" 
                            :rules="soundcloudRules"
                        ></v-text-field> -->
                        <v-textarea 
                            label="Comments" 
                            v-model="current_song.comments" 
                            prepend-icon="mdi-pencil"
                        ></v-textarea>
                    </v-form>
                </v-card-text>

                <!-- <v-divider></v-divider> -->

                <v-card-actions>
                    <v-btn class="error mb-3 ml-5" text @click="dialog = false">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="primary mb-3 mr-5" text :loading="loading" @click="submitEdit"> 
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="text-center ma-2">
            <v-snackbar color='syn_green' v-model="snackbar" :timeout="timeout">
                {{ snackbarText }}
                <v-btn color="white" text @click="snackbar = false"> Close </v-btn>
            </v-snackbar>
        </div>
    </div>


</template>

<script>
import fb from '@/fb'
const db = fb.db

export default {
    name: 'EditSong',
    data() {
        return {
            dialog: false,
            titleRules: [
                v => !!v || 'Title is required',
                v => (v && v.length >= 3) || 'Title must be greater than 3 characters',
                v => (v && v.length <= 30) || 'Title must be less than 30 characters'
            ],
            genreRules: [
                v => !!v || 'Genre is required'
            ],
            loading: false,
            genreItems: ['House / Dance','Bass Music','Hip Hop','Pop', 'Ambient','Experimental','Other'],
            snackbarText: null,
            timeout: 4000,
            snackbar: false
        }
    },
    props: {
        current_user_id: String,
        current_song: Object
    },
    methods: {
        submitEdit() {
            if (this.$refs.form.validate()){
                this.loading = true
                
                db.collection('songs').doc(this.current_song.song_id).update({
                    title: this.current_song.title,
                    genre: this.current_song.genre,
                    // audioPath: this.current_song.audioPath,
                    comments: this.current_song.comments
                }).then(()=>{
                    // console.log('Successfully edited');
                    // reset everything
                    this.dialog=false
                    this.loading=false
                    this.$emit('editSuccess');
                    this.snackbarText = "Successfully updated!"
                    this.snackbar = true
                }).catch(err => {
                    console.log(err)
                })
                
            }
        },
        cancel(){
            this.title = null
            this.description = null
        }
    }
}
</script>